import { useState } from 'react';

import Button from '@app/components/button';
import FlowManager from '@app/components/cancel-subscription/flow-manager';
import { T } from '@app/components/translation';

import { amplitudeLogEvent } from '@flow/libs/client-analytics/amplitude';
import style from './cancellation.module.scss';

const CancellationFlowComponent = () => {
  const [showCancellationModal, setShowCancellationModal] = useState<boolean>(false);

  const handleCloseClick = () => {
    setShowCancellationModal(false);
  };

  const handleOpenClick = () => {
    setShowCancellationModal(true);
    amplitudeLogEvent('Go To Cancel Subscription');
  };

  return (
    <>
      {showCancellationModal && <FlowManager onClose={handleCloseClick} />}
      <Button
        kind="link"
        color="forest-green"
        onClick={handleOpenClick}
        customClass={style.CancelButton}
      >
        <T
          _str="Cancel Subscription Plan"
          _comment="Button to cancel subscription plan"
        />
      </Button>
    </>
  );
};

export default CancellationFlowComponent;
